export default {
  black: "#000000",
  dark: "#001E2D",
  darkHover: "#263F4C",
  darkActive: "#001E2D",
  gray: "rgba(0,30,45,0.1)",
  gray5: "rgba(0,30,45,0.05)",
  gray10: "rgba(0,30,45,0.1)",
  gray30: "rgba(0,30,45,0.3)",
  gray60: "rgba(0,30,45,0.6)",
  grayLight: "#F1F3F4",
  grayLight10: "rgba(255,255,255,0.1)",
  grayLight20: "rgba(255,255,255,0.2)",
  green: "#28B450",
  orange: "#F27042",
  red: "#EF4E52",
  redLight: "rgba(239,78,82,0.3)",
  get tealGradient() {
    return `linear-gradient(225deg, #13B7BF 0%, ${this.teal} 100%)`
  },
  teal: "#00939A",
  tealHover: "#007F85",
  tealActive: "#006E73",
  tealLight: "#F2F9FA",
  tealLight2: "rgba(0,147,154,0.1)",
  tealLight2NonAlpha: "#E6F5F5",
  tealLight3: "rgba(0,147,154,0.2)",
  modalBackdrop: "rgba(230,245,245,.9)",
  white: "#ffffff",
  yellowDhl: "#FFCC00",

  // Country zone colors
  zone1: "#E6F5F5",
  zone2: "#00939A",
  zone3: "#7BC5C8",
  zone4: "#28B450",
  zone5: "#596FBB",
}

export const hexToRgba = (hex: string, alpha: number) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)!
  return `rgba(${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(
    result[3],
    16
  )},${alpha})`
}
